var map = {
	"./iggidaugavpils/iggid_1.jpeg": 5196,
	"./iggidaugavpils/iggid_2.jpeg": 7289,
	"./iggidaugavpils/iggid_3.jpeg": 5496,
	"./iggidaugavpils/iggid_4.jpeg": 68,
	"./iggidaugavpils/iggid_5.jpeg": 4786,
	"./iggidaugavpils/iggid_6.jpeg": 9296,
	"./iggirezekne/iggir_1.jpg": 313,
	"./iggirezekne/iggir_2.jpg": 7845,
	"./iggirezekne/iggir_3.jpeg": 4541,
	"./iggirezekne/iggir_4.jpg": 4672,
	"./iggirezekne/iggir_5.jpg": 3190,
	"./iggirezekne/iggir_6.jpg": 6028,
	"./osteria/osteria_1.jpg": 1716,
	"./osteria/osteria_2.jpg": 2283,
	"./osteria/osteria_3.jpg": 4716,
	"./osteria/osteria_4.jpg": 5498,
	"./osteria/osteria_5.jpg": 1383,
	"./osteria/osteria_6.jpeg": 6746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2438;